import { GeoCompany, Kpi } from 'models/response';
import { Option } from 'react-multi-select-component';
import { SearchParams } from './interfaces';
import utils from 'utils';

export const createFiltersObject = (searchParams?: SearchParams) => {
  const { dateFrom, dateTo, companies, types, channels, gbsList } = searchParams || {};

  const idCompanyList = companies?.map(({ value }: { value: number }) => value);
  const idDocTypeList = types?.map(({ value }: { value: number }) => value);
  const incChannelList = channels?.map(({ value }: { value: number }) => value);
  const idGbsList = gbsList?.map(({ value }: { value: number }) => value);

  return {
    dateFrom: dateFrom || '',
    dateTo: dateTo || '',
    idCompanyList,
    idDocTypeList,
    incChannelList,
    idGbsList,
  };
};

export const getCompaniesFromGbsList = (gbsList?: GeoCompany[], selectedGbsList?: Option[]) => {
  const selectedCompanies = selectedGbsList
    ?.map((selectedItem) => {
      const gbs = gbsList?.find((gbsItem) => gbsItem.idGbs === selectedItem.value);
      return gbs ? gbs.companyList : [];
    })
    .reduce((acc, companyList) => acc.concat(companyList), []);

  return selectedCompanies || [];
};

export const formatKpiValue = (t: (label: string) => string, kpi: Kpi) => {
  if (!kpi.result) return 'n/a';

  const unit = kpi.formatType === 'PERCENTAGE' ? '%' : utils.app.textTranslated(kpi.timeframePeriod, t) || '';

  return `${kpi.result} ${unit}`.trim();
};
